import React, { useEffect, useState } from "react";
import walletC from "../Assets/walletC.svg";
import qr from "../Assets/qr.PNG";
import { AiOutlineClose } from "react-icons/ai";
import { othersWallet } from "../utils/mockup.js";
import { CgSpinner } from "react-icons/cg";

const WalletConnectModal = ({ setWalletCn, setModal, setImportWallet }) => {
  const [active, setActive] = useState(2);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const itemsPerPage = 12;
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = searchResults.slice(indexOfFirstItem, indexOfLastItem);

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 2000); // 2000 milliseconds = 2 seconds

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(othersWallet.length / itemsPerPage); i++) {
    pageNumbers.push(i);
  }
  const handleChange = (e) => {
    setSearchTerm(e.target.value);
  };

  React.useEffect(() => {
    // Filter the data based on the search term
    const filteredData = othersWallet.filter((item) =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    setSearchResults(filteredData);
  }, [searchTerm]);
  return (
    <section className="fixed inset-0 top-0 flex items-center justify-center p-1 transition-10 duration-50 outline-0 ">
      {loading ? (
        <div className="md:w-[440px] w-full h-80 flex items-center justify-center rounded-md bg-white drop-shadow-2xl">
          <CgSpinner className="text-blue-500 animate-spin" size={30} />
        </div>
      ) : (
        <div className="md:w-[440px] w-full">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center space-x-2">
              <img src={walletC} alt="walletC" className="w-10" />
              <p className=" text-xl text-black font-[600]">WalletConnect</p>
            </div>
            <AiOutlineClose
              onClick={() => setWalletCn(false)}
              className="p-1 text-3xl text-black bg-white rounded-full cursor-pointer "
            />
          </div>
          <div className="md:w-[440px] w-full rounded-3xl bg-white drop-shadow-2xl">
            <div className="flex-col items-center p-4 space-y-4 lg:flex md:flex lg:p-8 ">
              <div className="bg-[#d4d5d9] flex  space-x-2 items-center text-center p-1 lg:w-96 md:w-96 rounded-md">
                {[
                  {
                    name: "QR Code",
                    id: 1,
                  },
                  {
                    name: "Desktop",
                    id: 2,
                  },
                ].map((item) => (
                  <button
                    onClick={() => setActive(item.id)}
                    key={item.id}
                    className={`${
                      item.id === active ? "bg-white" : ""
                    } text-[#08fdfe] rounded-md w-full py-1 px-4`}
                  >
                    {item.name}
                  </button>
                ))}
              </div>
              <p className="text-lg text-[#767676] font-[700]">
                {active === 2
                  ? "Choose your preferred wallet"
                  : "Scan QR code with a WalletConnect-compatible wallet"}
              </p>
              {active === 2 && (
                <input
                  value={searchTerm}
                  onChange={handleChange}
                  placeholder="Search"
                  className="bg-[#d4d5d9] w-full rounded-md px-4 py-2 mb-4 outline-0"
                />
              )}

              {active === 2 ? (
                <>
                  <div className="p-3 px-0 ">
                    <div className="grid grid-cols-3 gap-1 lg:grid-cols-4 lg:gap-3 ">
                      {currentData.map((item) => (
                        <div
                          key={item.id}
                          className="flex flex-col items-center gap-1 p-1 text-white cursor-pointer hover:opacity-80 rounded-xl"
                          onClick={() => {
                            setWalletCn(false);
                            setModal(false);
                            setImportWallet(true);
                          }}
                        >
                          <img src={item.icon} alt="" className="w-5  lg:w-7" />
                          <p className=" text-black text-xs text-center  font-[600]">
                            {item.name}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="flex items-center justify-center space-x-2 text-center">
                    {pageNumbers.map((number) => (
                      <button
                        key={number}
                        onClick={() => handlePageChange(number)}
                      >
                        {number}
                      </button>
                    ))}
                  </div>
                </>
              ) : (
                <>
                  <img src={qr} alt="qr" />
                  <p className="cursor-pointer">Copy to clipboard</p>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default WalletConnectModal;
